module.exports = __webpack_public_path__ + "static/media/file_download.6130770a.svg";